import { render, staticRenderFns } from "./DoorPlateEquipment.vue?vue&type=template&id=390b84e8&scoped=true&"
import script from "./DoorPlateEquipment.vue?vue&type=script&lang=js&"
export * from "./DoorPlateEquipment.vue?vue&type=script&lang=js&"
import style0 from "./DoorPlateEquipment.vue?vue&type=style&index=0&id=390b84e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b84e8",
  null
  
)

export default component.exports